import makeStyles from '@mui/styles/makeStyles';
import { isDark } from '../../styles';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: theme.spacing(4),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',

    '& .MuiTypography-root': {
      color: isDark(theme) ? theme.colors.white : theme.palette.primary.main,
    },
  },
  paper: {
    padding: theme.spacing(2),
    width: '100%',
    maxWidth: '512px',
    textAlign: 'center',
  },
  iconLarge: {
    fontSize: '6rem',
    color: isDark(theme) ? theme.colors.white : theme.palette.primary.light,
  },
  iconSmall: {
    fontSize: '1rem',
  },
  button: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.dark,
  },
}));

export default useStyles;
